var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimbol2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171.32 166.69",
    style: {
      enableBackground: "new 0 0 171.32 166.69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M30.71,48.71C20.23,52.75,11.02,61.59,7,75.5c-3.89,13.44,0.67,29.02,11.4,38s27.1,10.65,39.27,3.75 c9.47-5.37,15.94-20.94,18.32-31.57C84.19,49.14,54.25,39.63,30.71,48.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M155.52,38.43c-3.84-1.99-8.32-2.35-12.64-2.16c-6.1,0.27-12.33,1.66-17.32,5.19 c-4.98,3.53-8.51,9.51-7.94,15.6c0.68,7.36,6.82,12.97,13.02,16.99c7.54,4.9,17.25,8.65,25.31,4.68c5.39-2.65,8.83-8.41,9.73-14.35 C166.98,55.72,164,42.83,155.52,38.43z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimbol2);
export default __webpack_public_path__ + "static/media/simbol2.8a4b2100cfcf50c935dcaec06d4db324.svg";
export { ForwardRef as ReactComponent };